module.exports = __webpack_public_path__ + "static/media/news-vp-finance.69a4427c.jpg";